import React from 'react'

import cn from './styles.module.scss'

export interface ISpinnerProps {
  width?: number
  height?: number
  color?: 'black' | 'white' | 'gradient' | 'grey'
}

const primaryColor = 'var(--clr-primary-400)'

const Spinner = ({
  width = 10,
  height = 10,
  color = 'black',
}: ISpinnerProps) => {
  const greyColor = color === 'grey' ? '#b5b5b5' : color
  const newColor = color === 'gradient' ? 'var(--clr-primary-400)' : greyColor

  return (
    <svg
      className={cn.spin}
      viewBox='0 0 50 50'
      style={{ width, height }}
      fill='none'
    >
      <defs xmlns='http://www.w3.org/2000/svg'>
        <linearGradient
          id='gradient-spinner'
          x1='0'
          y1='0'
          x2='20'
          y2='0'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0%' stopColor='#17a2c3' />
          <stop offset='14.285714285714285%' stopColor='#0096c1' />
          <stop offset='28.57142857142857%' stopColor='#008bbe' />
          <stop offset='42.857142857142855%' stopColor='#007eba' />
          <stop offset='57.14285714285714%' stopColor='#0072b6' />
          <stop offset='71.42857142857142%' stopColor='#0065af' />
          <stop offset='85.71428571428571%' stopColor='#0058a7' />
          <stop offset='100%' stopColor={primaryColor} />
        </linearGradient>
      </defs>

      <circle
        className={cn.spinPath}
        cx='25'
        cy='25'
        r='20'
        stroke={newColor}
        strokeWidth='5'
      ></circle>
    </svg>
  )
}

export default Spinner
